// This file is autogenerated. Any changes will be overwritten.
export const name = 'arrow-micro-down';

export const Component = () => (
  <path d='M8,10 C8,10 16.8125,10 16.8125,10 C16.8125,10 12.5023437,14.8851562 12.5023437,14.8851562 C12.5023437,14.8851562 8.00078125,10 8.00078125,10 L8,10 Z' />
);

export const viewBox = '0 0 25 25';
